import { log } from '@libs/utils';

import type { MapParent } from '../maps';

declare global {
  interface Window {
    dataLayer?: object[];
  }
}

const existingMapParents: Node[] = [];

export function trackMapLoad(mapParent: MapParent): void {
  const clonedMapParent = mapParent.cloneNode();
  const mapParentExists = existingMapParents.some((existingMapParent) =>
    clonedMapParent.isEqualNode(existingMapParent)
  );
  const eventName = mapParentExists ? 'mapReload' : 'mapLoad';
  if (!mapParentExists) {
    existingMapParents.push(clonedMapParent);
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: eventName,
  });
  log({ title: eventName });
}
